<template>
  <div>
    <ul class="nav nav-tabs mb-4">
      <li class="nav-item">
        <div class="nav-link active">Failed Payments</div>
      </li>
    </ul>
    <DatatableReportV3
      id="failed-payments-table"
      :source="source"
      :config="config"
      :filters="filters"
      :no-download="true"
    />
  </div>
</template>

<script>
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";
import ManualRetryButton from "@/Reports/ManualRetryButton.vue";
import store from "@/vuex/store";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      config: {
        order: [[0, "asc"]],
        columns: [
          { data: "customer", title: "Customer" },
          {
            data: "address",
            title: "Address",
            searchable: false,
            orderable: false
          },
          {
            data: "program",
            title: "Membership Program",
            searchable: false,
            orderable: false
          },
          { data: "renewal_date", title: "Renewal Date", searchable: false },
          { data: "amount", title: "Amount", searchable: false },
          { data: "invoice", title: "Invoice" },
          {
            data: "card",
            title: "Card",
            searchable: false,
            orderable: false
          },
          { data: "last_attempt", title: "Last Attempt", searchable: false },
          {
            data: "auto_retry_status",
            title: "Auto Retry Status",
            searchable: false,
            orderable: false
          },
          {
            data: "actions",
            title: "",
            searchable: false,
            orderable: false,
            className: "text-center"
          }
        ],
        vueComponents: [
          {
            rootId: "manual-retry-button-vue",
            component: ManualRetryButton,
            options: { store }
          }
        ]
      }
    };
  }
};
</script>

<style>
#failed-payments-table tr.retry-highlighted,
#failed-payments-table tr.retry-highlighted:hover,
#failed-payments-table tr.retry-highlighted td {
  background-color: #d4edda !important;
}
</style>
